import React from 'react'
import { useTranslation } from 'react-i18next'
import BrainlyMathEditor from '@/components/UI/TextAreaNewVersion/BrainlyMathEditor'
import { BrainlyMathEditorSimple } from '@/components/UI/TextAreaNewVersion'
import InfoBlock from '../../OldPortalComponents/InfoBlock'

interface TextQuestionProps {
  questionId: string
  idealAnswer: string
  onAnswerChange: (value: string) => void
}

const TextQuestion: React.FC<TextQuestionProps> = ({
  questionId,
  idealAnswer,
  onAnswerChange,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <h4 className="page-subheading">{t('Answer key')}</h4>
      <InfoBlock>
        {t(
          'Paragraph and non-paragraph based answer have a different scoring mechanism. If the ideal answer has multiple parts please use bulleted or numbered list.',
        )}
      </InfoBlock>
      <BrainlyMathEditorSimple
        key={`ideal-answer-${questionId}`}
        value={idealAnswer}
        onChange={onAnswerChange}
        placeholder={t('Type answer here')}
        height="200px"
        minHeight="150px"
      />
    </>
  )
}

export default TextQuestion
